import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import InvoiceViewer from './InvoiceViewer';
import ReceiptViewer from './ReceiptViewer';
import ShopzoLanding from './shopzoLanding';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/invoice/:invoiceId" element={<InvoiceViewer />} />
        <Route path="/receipt/:receiptid" element={<ReceiptViewer />} />
        {/* <Route path="*" element={<ShopzoLanding />} /> */}
      </Routes>
    </Router>
  );
}

export default App; 